import React, { Component } from 'react';
import './HostNewGameOnlineForm.css';
import { ConnectedUserList } from './ConnectedUserList';

export class JoinOnlineGameForm extends Component {
    static displayName = "Join online session";

    intervalID;

  constructor(props) {
      super(props);
      
      this.state = { gameSessionId: props.match.params.gameSessionId, wordsets: [], loading: true, errorText: "", connectedPlayers: [], movingToGame: false, myusername: "", myTeam: 2 };
  }

  componentDidMount() {
      this.joinSession();
    }

    componentWillUnmount() {
        this.stopServerPolling();
    }

    stopServerPolling() {
        clearTimeout(this.intervalID);
    }

    updateGameStateSync = () => {
        fetch('game/state')
            .then(r => r.json())
            .then(data => {
                this.setState({ connectedPlayers: data.connectedPlayers });

                if (data.gameState != null) {
                    this.setState({ movingToGame: true });
                    //this.props.history.push('online-game-board/');
                    window.location = "/online-game-board";
                    return;
                }

                this.intervalID = setTimeout(this.updateGameStateSync.bind(this), 2000);
            });
    }

    async updateUsername() {
        await fetch('session/username', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: '"' + this.state.myusername + '"'
        });
    }

    async updateMyTeam() {
        await fetch('session/team-preference', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: this.state.myTeam
        });
    }

    renderJoinGameForm() {
        return (<div className="container">
            Waiting for game host to start the next game round.

            <div>
                <ConnectedUserList users={this.state.connectedPlayers} />
            </div>

            <div>
                <label>Set username</label>
                <input value={this.state.myusername} type="text" onChange={x => this.setState({ myusername: x.target.value })} />
                <button className={"btn btn-primary"} onClick={async () => { await this.updateUsername() }}>Update username</button>
            </div>
            <div>
                <label>Set your team (1 or 2)</label>
                <input value={this.state.myTeam} type="text" onChange={x => this.setState({ myTeam: x.target.value })} />
                <button className={"btn btn-primary"} onClick={async () => { await this.updateMyTeam() }}>Update team</button>
            </div>
        </div>);
    }

  render() {
    let contents = this.state.loading
      ? <p><em>Loading...</em></p>
        : this.renderJoinGameForm();

    return (
      <div>
        {contents}
      </div>
    );
  }

    joinSession = () => {
        fetch('session/join', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: '"' + this.state.gameSessionId + '"'
        })
            .then(r => r.json())
            .then(data => {
                this.setState({ loading: false, connectedPlayers: data.connectedPlayers, myusername: data.myUsername });
                this.intervalID = setTimeout(this.updateGameStateSync.bind(this), 2000);
            });
  }
}
